<script setup lang="ts">
import { useCommonCodeStore } from '~/store/commonCodeStore';


const commonCodeStore = useCommonCodeStore();

const props = defineProps<{
  apiData: any
}>()

console.log(props.apiData);

const emits = defineEmits(["callApi"]);

const normalDataCount = computed(() => commonUtils.isAllStrDataEmpty(props.apiData?.totalOperEquipStatus.find(v => v.opStatus === 'normal').count));
const preparingDataCount = computed(() => commonUtils.isAllStrDataEmpty(props.apiData?.totalOperEquipStatus.find(v => v.opStatus === 'preparing').count));
const warningDataCount = computed(() => commonUtils.isAllStrDataEmpty(props.apiData?.totalOperEquipStatus.find(v => v.opStatus === 'warning').count));
const faultDataCount = computed(() => commonUtils.isAllStrDataEmpty(props.apiData?.totalOperEquipStatus.find(v => v.opStatus === 'fault').count));
const downDataCount = computed(() => commonUtils.isAllStrDataEmpty(props.apiData?.totalOperEquipStatus.find(v => v.opStatus === 'down').count));



</script>

<template>
  <div class="basic-info-card common-card">
    <div class="header">
      <div class="title">
        운영중 설비
      </div>
    </div>
    <div class="contents">
      <div class="left-contents">
        <p>전체 개수</p>
        <p>{{ props.apiData ? commonUtils.isAllStrDataEmpty(props.apiData.operEquipCount) : '-' }}</p>
      </div>
      <div class="right-contents">
        <div class="status-wrapper">
          <div class="status-info status-normal">
            <span>정상</span>
            <span>{{ normalDataCount ? commonUtils.isAllStrDataEmpty(normalDataCount) : '-' }}</span>
          </div>
          <div class="status-info status-preparing">
            <span>준비중</span>
            <span>{{ preparingDataCount ? preparingDataCount : '-' }}</span>
          </div>
          <div class="status-info status-warning">
            <span>경고</span>
            <span>{{ warningDataCount ? warningDataCount : '-' }}</span>
          </div>
          <div class="status-info status-fault">
            <span>고장</span>
            <span>{{ faultDataCount ? faultDataCount : '-' }}</span>
          </div>
          <div class="status-info status-down">
            <span>미작동</span>
            <span>{{ downDataCount ? downDataCount : '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/basic-card.scss";
@use "@/assets/styles/design-toc/define.scss";
@use "@/assets/styles/design-toc/common-card.scss";
</style>